import { useEffect } from 'react';
import FilterBox from './components/element/FilterBox';
import MainContent from './components/element/mainContent';

export default function PlpPage() {
  useEffect(() => {
    if (document.activeElement) {
      (document.activeElement as HTMLElement).blur();
    }
  }, []);

  return (
    <div className="min-h-[100px]">
      {/*  قسمت زیر هدر اصلی برای رد لیست فیلترهای صفحه*/}
      <FilterBox />
      <div className="container min-h-screen mx-auto">
        <MainContent />
      </div>
    </div>
  );
}
